  (function () {
    if (window.__imageTextSideBySideHasFired) {
      return;
    }

    window.Branch = window.Branch || {};
    window.Branch.imageTextSideBySide = window.Branch.imageTextSideBySide || {};
    window.__imageTextSideBySideHasFired = true;

    function savingsChart() {
        var savingsChartElement = document.getElementById('savings-chart');
        if(savingsChartElement){
            function drawSavingsChart(){
                $("#bars li .bar").each( function( key, bar ) {
                var percentage = $(this).data('percentage');

                $(this).animate({
                    'height' : percentage + '%'
                }, 1000);
                });
            }

            drawSavingsChart();
        }
    }

    function actionsOnVisible(uninitializedImageTextSideBySideSection){
        uninitializedImageTextSideBySideSection.setAttribute('data-interacted', true);
        window.Branch.nav.handleUpdateSrcSet(null, '.image-text-side-by-side__image', '.image-text-side-by-side__flex-item[data-type="image"]', 1280);     
        savingsChart();
    }

    function initImageTextSideBySideCallback(uninitializedImageTextSideBySideSection, parent, type){
        let fromLoad = uninitializedImageTextSideBySideSection.closest('.homepage-content-container') && uninitializedImageTextSideBySideSection.closest('.homepage-content-container').getAttribute('data-origin') == 'load';

        if(type == 'from-copy' && fromLoad == false){
            actionsOnVisible(uninitializedImageTextSideBySideSection);
        } else if(!uninitializedImageTextSideBySideSection.closest('.homepage-content-container')) {
            actionsOnVisible(uninitializedImageTextSideBySideSection);
        } else {
            const scrollHandler = function () {
            const containerRect = {top: 0, left: 0, bottom: window.innerHeight, right: window.innerWidth, width: window.innerWidth, height: window.innerHeight};
            const targetRect = uninitializedImageTextSideBySideSection.getBoundingClientRect();

            const isVisible =
                targetRect.bottom > containerRect.top &&
                targetRect.top < containerRect.bottom;

            if (
                isVisible &&
                uninitializedImageTextSideBySideSection.getAttribute("data-interacted") !== "true"
            ) {
                actionsOnVisible(uninitializedImageTextSideBySideSection, parent);
                uninitializedImageTextSideBySideSection.setAttribute("data-interacted", "true");
                window.removeEventListener("scroll", scrollHandler);
            }
        };

        window.addEventListener("scroll", scrollHandler);
        }
    }

    window.Branch.imageTextSideBySide.initImageTextSideBySide = function(type){
        let uninitializedimageTextSideBySide = document.querySelectorAll('.shopify-section.feature-box:not([data-initialized="true"])');
        uninitializedimageTextSideBySide.forEach((uninitializedImageTextSideBySideSection) => {
            let parent = uninitializedImageTextSideBySideSection.closest('.shopify-section');
            uninitializedImageTextSideBySideSection.setAttribute('data-initialized', true);
            if(type == 'from-copy'){
                initImageTextSideBySideCallback(uninitializedImageTextSideBySideSection, parent, type)
            } else {
                window.Branch.functions.fireOnUserInteraction(initImageTextSideBySideCallback,  '.homepage-content-container', uninitializedImageTextSideBySideSection, uninitializedImageTextSideBySideSection, parent);
            }
        })
    }

    if (document.readyState === "complete") {
        window.Branch.imageTextSideBySide.initImageTextSideBySide('regular'); 
    } else {
        window.addEventListener("load", () => window.Branch.imageTextSideBySide.initImageTextSideBySide('regular'));
    }
  })();
